import { render } from "./existing.vue?vue&type=template&id=20a64b20"
import script from "./existing.vue?vue&type=script&lang=js"
export * from "./existing.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__